import posthog from 'posthog-js';

const POSTHOG_KEY = (globalThis?.process?.env?.EXPO_PUBLIC_POSTHOG_KEY || '').trim();
const POSTHOG_HOST = (globalThis?.process?.env?.EXPO_PUBLIC_POSTHOG_HOST || 'https://us.i.posthog.com').trim();

let isInitialized = false;

const isBrowser = () => typeof window !== 'undefined' && typeof document !== 'undefined';

const withContext = (properties = {}) => ({
    platform: isBrowser() ? 'web' : 'native',
    pathname: isBrowser() ? window.location.pathname : undefined,
    ...properties,
});

export const isTelemetryEnabled = () => Boolean(POSTHOG_KEY) && isBrowser();

export function initTelemetry() {
    if (isInitialized || !isTelemetryEnabled()) {
        return false;
    }

    posthog.init(POSTHOG_KEY, {
        api_host: POSTHOG_HOST,
        defaults: '2026-01-30',
        autocapture: true,
        capture_pageview: false,
        persistence: 'localStorage+cookie',
        person_profiles: 'identified_only',
        loaded: (client) => {
            client.register({
                app_name: 'snapcamp',
                app_surface: 'marketplace',
            });
        },
    });

    isInitialized = true;
    return true;
}

export function trackEvent(name, properties = {}) {
    if (!isTelemetryEnabled() || !isInitialized) {
        return;
    }

    posthog.capture(name, withContext(properties));
}

export function trackScreen(pathname, search = '') {
    if (!isTelemetryEnabled() || !isInitialized || !pathname) {
        return;
    }

    posthog.capture('$pageview', {
        pathname,
        search,
        $current_url: isBrowser() ? window.location.href : pathname,
    });
}

export function identifyUser(userId, properties = {}) {
    if (!isTelemetryEnabled() || !isInitialized || !userId) {
        return;
    }

    posthog.identify(userId, withContext(properties));
}

export function resetTelemetry() {
    if (!isTelemetryEnabled() || !isInitialized) {
        return;
    }

    posthog.reset();
}

export function sanitizeTelemetryError(error, fallback = 'unknown_error') {
    if (error instanceof Error) {
        return {
            error_name: error.name || fallback,
            error_message: (error.message || fallback).slice(0, 180),
        };
    }

    if (typeof error === 'string') {
        return {
            error_name: fallback,
            error_message: error.slice(0, 180),
        };
    }

    return {
        error_name: fallback,
    };
}
